import React from "react"
import { FormattedMessage } from "react-intl"
import { INavTab } from "components/Shared/NavTabs/interfaces"
import * as paths from "constants/paths"
import Components from "./components"
import Container from "components/Shared/Container"
import {
	deleteOrganization,
	deleteUser,
	getOrganizations,
	getUsers,
} from "./service"
import {
	organizationsColumnsHeader,
	usersColumnsHeader,
} from "./components/List/Table/utils"
import { AdministrationOptions, TableConfiguration } from "./interfaces"

export enum ROLES {
	CONSULTANT = "consultant",
}

export const USERS = "users"
export const ORGANIZATIONS = "organizations"
const TabText = "phronesis.usermanagement.tab."

export const TabsOptions: Array<INavTab> = [
	{
		text: <FormattedMessage id={TabText + USERS} />,
		pathname: paths.ROOT_CONTEXT + paths.USER_MANAGEMENT,
		component: (
			<Container>
				<Components section="users" />
			</Container>
		),
	},
	{
		text: <FormattedMessage id={TabText + ORGANIZATIONS} />,
		pathname: paths.ROOT_CONTEXT + paths.ORGANIZATIONS_MANAGEMENT,
		component: (
			<Container>
				<Components section="organizations" />
			</Container>
		),
	},
]

export const SectionProps: Record<AdministrationOptions, TableConfiguration> = {
	[USERS]: {
		id: "email",
		columns: [
			{
				column: "email",
				dataIndex: "email",
			},
			{
				column: "firstName",
				dataIndex: "firstName",
			},
			{
				column: "lastName",
				dataIndex: "lastName",
			},
			{
				column: "roles",
				dataIndex: "roles",
				render: (value: Array<string>) =>
					value.map((rol) => <li key={rol}>{rol}</li>),
			},
			{
				column: "organization",
				dataIndex: "organization.name",
			},
		],
		headers: usersColumnsHeader,
		endpoint: {
			get: getUsers,
			delete: deleteUser,
		},
	},
	[ORGANIZATIONS]: {
		id: "name",
		columns: [
			{
				column: "name",
				dataIndex: "name",
			},
			{
				column: "description",
				dataIndex: "description",
			},
			{
				column: "plans",
				dataIndex: "plans",
				render: (value: Array<string>) =>
					value.map((plan) => <li key={plan}>{plan}</li>),
			},
		],
		headers: organizationsColumnsHeader,
		endpoint: {
			get: getOrganizations,
			delete: deleteOrganization,
		},
	},
}

export const BREADCRUMBS = [
	{
		name: "Configuración",
		path: paths.USER_MANAGEMENT,
	},
	{
		name: "Panel de administración",
		path: paths.USER_MANAGEMENT,
	},
]
